import { esc } from './formato.js';

export function toast(msg){
  const t = document.getElementById('toast');
  t.innerHTML = `<div class="toast">${esc(msg)}</div>`;
  clearTimeout(window._tt); window._tt = setTimeout(()=>t.innerHTML='',3200);
}
